import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { TemplateGalleryLoader } from '@confluence/template-gallery';

export const TemplateGalleryRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ name }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
			};
			pageState: {
				routeName: string;
			};
		};
		MainLayout: {
			navView: string;
			disableMinWidth: boolean;
		};
	};
} = (): React.JSX.Element => <TemplateGalleryLoader />;

TemplateGalleryRoute.NAVIGATION_PARAMS = ({
	name,
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
		};
		pageState: {
			routeName: string;
		};
	};
	MainLayout: {
		navView: string;
		disableMinWidth: boolean;
	};
} => ({
	Screen: {
		screenEvent: { name: 'templateGalleryScreen' },
		pageState: { routeName: name },
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
		disableMinWidth: true,
	},
});
